import React, { useState, useEffect } from 'react';
import routes from 'js/core_pre_webpack/routes';
import styled from 'astroturf/react';
import * as ApiUtils from 'js/utils/api_utils';
import { CoauthorSuggestion, CoauthorTag } from 'js/social/shared/types';
import CoauthorConfirmationCard from './CoauthorConfirmationCard';
import { default as SidebarBase } from './shared/SuggestedContentSidebar';

interface Props {
  className?: string;
}

const SuggestedContentSidebar = styled(SidebarBase)`
  margin-bottom: -12px;
`;

const MAX_SUGGESTION_COUNT = 2;

export default function CoauthorConfirmations(props: Props) {
  const [suggestedCoauthors, setSuggestedCoauthors] = useState<
    CoauthorSuggestion[]
  >([]);
  const [loading, setLoading] = useState(true);

  const getCoauthorConfirmations = (): Promise<CoauthorSuggestion[]> => {
    return ApiUtils.get(
      routes.api_v0_suggestions_coauthors_path({
        subdomain_param: 'api',
      }),
    );
  };

  const submitCoauthorConfirmation = (
    accepted: boolean,
    tag: CoauthorTag,
  ): Promise<any> => {
    // remove null records prevents errors on the back
    // end when trying to create a new CoAuthorTag or
    // CoAuthorTagSuggestion
    const compactedTag: CoauthorTag = { ...tag };
    Object.keys(compactedTag).forEach((k) => {
      const value = tag[k as keyof CoauthorTag];
      if (value === null) {
        delete compactedTag[k as keyof CoauthorTag];
      }
    });

    return ApiUtils.post(
      routes.api_v0_suggestions_coauthors_path({
        subdomain_param: 'api',
        ...compactedTag,
        accepted,
      }),
    );
  };

  useEffect(() => {
    getCoauthorConfirmations().then((res) => {
      setSuggestedCoauthors(res.slice(0, MAX_SUGGESTION_COUNT));
      setLoading(false);
    });
  }, []);

  const removeCoauthorTag = (suggestionIdx: number, removedTagIdx: number) => {
    setSuggestedCoauthors((suggestedCoauthors) => {
      const suggested = suggestedCoauthors;
      suggested[suggestionIdx].tags.splice(removedTagIdx, 1);
      return suggested.filter((suggestion) => suggestion.tags.length > 0);
    });
  };

  if (suggestedCoauthors.length === 0) {
    return null;
  }

  return (
    <SuggestedContentSidebar
      headerText="Confirm co-authors"
      className={props.className}
      impressionSource="soc_home_sugg-a"
    >
      {!loading &&
        suggestedCoauthors
          .slice(0, MAX_SUGGESTION_COUNT)
          .map((suggestion, idx) => {
            return (
              <li key={suggestion.name}>
                <CoauthorConfirmationCard
                  coauthorSuggestion={suggestion}
                  submitCoauthorConfirmation={submitCoauthorConfirmation}
                  removeCoauthorTag={(removedTagIdx) =>
                    removeCoauthorTag(idx, removedTagIdx)
                  }
                />
              </li>
            );
          })}
    </SuggestedContentSidebar>
  );
}
